module.exports = __webpack_public_path__ + "img/GHS(Button).746259d7.svg";